import _ from 'lodash'
import React from 'react'
import Button from '@mui/material/Button'
import { Form, Image } from 'react-bootstrap'
import configuration from '../../utils/configuration'
import { useDispatch, useSelector } from 'react-redux'

import { isModel } from '../../helpers/storage/user'
import ChatWindowAttachment from './ChatWindowAttachment'
import QuillEditor from '../../components/helper/QuillEditor';
import { sendMessageSetInputData } from '../../store/actions/ChatAction'
import { ChatWindowBulkSenderHeaderDesktop } from './ChatWindowBulkSendHeader'

import './style_new.scss'

const ChatWindowBulkSend = ({
  setProgress,
  isSidebarClass,
  setShowProgress,
  onSendBulkMessage,
}) => {
  const dispatch = useDispatch()
  const {
    inputData: { assets, text, price },
  } = useSelector((state) => state.chat.sendMessage)
  const bulkSendUsers = useSelector((state) => state.chat.bulkSendUsers)

  const submitBtn = React.useRef()
 
  const onTextChange = (e) => {
    dispatch(
      sendMessageSetInputData({
        text: e.target.value
      })
    )
  }

  const onPriceChange = (e) => {
    dispatch(
      sendMessageSetInputData({
        price: e.target.value
      })
    )
  }

  const onSubmit = (e) => {
    e.preventDefault()
    onSendBulkMessage(
      bulkSendUsers?.selected,
      text,
      assets.map((item) => item.url),
      price
    )
  }

  const onMediaAttachment = (payload) => {
    dispatch(
      sendMessageSetInputData({
        assets: [...assets, ...payload]
      })
    )
  }

  const removeFile = (index) => {
    dispatch(
      sendMessageSetInputData({
        text,
        price,
        assets: assets.filter((_, i) => i !== index),
      })
    )
  }

  const getMessagePriceLimit = () => {
    const limit = configuration.get('configData.chatroom_message_lock_payment_limit')
    return limit || 0
  };

  return (
    <>
      <div className="chatwindowopen chatconversation">
        <ChatWindowBulkSenderHeaderDesktop isSidebarClass={isSidebarClass} />
        <div className="messageboxchat">
          <div className="messagesent">
            <ul className="messagesendin"></ul>
          </div>
        </div>
      </div>
      <div className="bottomchatwindow chatconversation">
        {assets.length > 0 && (
          <div className="attachments-list">
            <div className='attachments-list-header'>
              <h5>Attachments</h5>
            </div>
            <hr/>
            {assets.map((item, index) => (
              <div key={`file-${index}`} className="attachments-list-item align-items-center">
                <p className="col-10 col-md-11 mb-0">
                <a href={item.url} target="blank" aria-label={item.name}>
                  {item.name}
                </a>
                </p>
                <button className="btn float-right col-2 col-md-1" onClick={() => removeFile(index)} title='close'>
                  <i className="fas fa-times"></i>
                </button>
            </div>
            ))}
            <hr/>
            <div className="price-input mt-3">
              <label>Price (Optional)</label>
              <div className="input-group mb-3 pt-2">
                <div className="input-group-prepend">
                  <span className="input-group-text">$</span>
                </div>
                <input
                  min="1"
                  name="key"
                  type="number"
                  value={price}
                  pattern="[0-9]*"
                  placeholder={`Add price to lock message ${getMessagePriceLimit() ?  `(Max $${getMessagePriceLimit()})` : ''}`}
                  onChange={onPriceChange}
                  className="form-control price"
                />
              </div>
            </div>
          </div>
        )}
        <Form className="senditempart" onSubmit={onSubmit} translate='no'>
          <Form.Group className="d-flex align-items-start" controlId="formSearch">
            {isModel() && (
              <ChatWindowAttachment
                isActive={true}
                chatroom={`bulk-message-assets`}
                setProgress={setProgress}
                setShowProgress={setShowProgress}
                onMediaAttachment={onMediaAttachment}
              />
            )}
            <QuillEditor
              className='message-window overflow-y-hidden'
              id={`bulk-message-editor`}
              placeholder='Type your message here'
              value={text}
              onChange={(val) => onTextChange({
                target: {
                  value: val
                }
              })}
              handleSubmit={() => {
                submitBtn.current.click()
              }}
            />
            <Button ref={submitBtn} type="submit" className="primary btn btn-primary sendbtn">
              <Image src="https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/arrow-icons_send.svg" round alt='send arrow icon'/>
            </Button>
          </Form.Group>
        </Form>
      </div>
    </>
  )
}

export default ChatWindowBulkSend
